import { Avatar,IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAuthContext } from 'common/contexts/AuthContext';
import { stringAvatar } from 'common/services/profile';

export function ProfileButton() {
    const { userProfileInfo } = useAuthContext();

    const theme = useTheme();

    const isDark = theme.palette.mode === 'dark';
    const avatarStyle = {
        bgcolor: isDark ? theme.palette.primary.accent : theme.palette.secondary.dark,
        fontFamily: 'Source Sans Pro',
        fontSize: 15,
    };

    return (
        <IconButton sx={{ ml: 2 }} data-testid="profileButton" disableRipple>
            <Avatar
                alt={userProfileInfo?.name ?? undefined}
                sx={avatarStyle}
            >
                {stringAvatar(userProfileInfo?.name)}
            </Avatar>
        </IconButton>
    );
}
